module.exports = __webpack_public_path__ + "static/media/check-ok.d1c36dea.svg";